/*
 * Angular bootstraping
 */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { bootloader } from '@angularclass/hmr';
/*
 * App Module
 * our top level module that holds all of our components
 */
import { AppModule } from './app/app.module';

/*
 * Bootstrap our Angular app with a top level NgModule
 */
console.log('gg');
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => console.log('Angular bootstrapped'))
  .catch(err => console.error(err));
